export default __webpack_public_path__ + "static/media/highfive.f5355721.png";